var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1531_12266)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11.5,
    fill: "#FF8B00",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1514 21.9141L10.006 11.1654C9.9397 10.5428 10.4277 10 11.0539 10H20.1961C20.8223 10 21.3103 10.5428 21.244 11.1654L20.0986 21.9141C20.0416 22.4498 19.5896 22.8562 19.0508 22.8562H12.1993C11.6605 22.8562 11.2085 22.4498 11.1514 21.9141Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4532 14.5236L11.2486 21.9714C11.3057 22.5071 11.7577 22.9135 12.2964 22.9135H19.148C19.6867 22.9135 20.1387 22.5071 20.1958 21.9714L21.0965 13.5348C18.9889 14.5236 17.4873 14.3515 15.9329 13.7069C12.6417 12.342 11.1766 13.8031 10.5522 14.4258C10.5165 14.4614 10.4836 14.4942 10.4532 14.5236ZM13.3883 15.785C13.0297 15.9983 12.9118 16.4619 13.125 16.8205L13.6669 17.7319C13.8801 18.0905 14.3437 18.2084 14.7024 17.9952L15.6137 17.4533C15.9724 17.2401 16.0902 16.7765 15.877 16.4178L15.3352 15.5065C15.1219 15.1478 14.6583 15.03 14.2997 15.2432L13.3883 15.785ZM16.763 18.1421C16.9 17.7479 17.3305 17.5394 17.7246 17.6763L18.7262 18.0242C19.1203 18.1611 19.3288 18.5916 19.1919 18.9858L18.844 19.9873C18.7071 20.3815 18.2766 20.59 17.8824 20.4531L16.8809 20.1052C16.4867 19.9683 16.2782 19.5378 16.4151 19.1436L16.763 18.1421ZM13.2061 19.2936C12.7903 19.3284 12.4814 19.6936 12.5162 20.1094L12.6045 21.166C12.6393 21.5818 13.0045 21.8907 13.4203 21.8559L14.4769 21.7675C14.8927 21.7328 15.2016 21.3675 15.1668 20.9517L15.0785 19.8951C15.0437 19.4793 14.6784 19.1705 14.2626 19.2052L13.2061 19.2936Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1531_12266",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1531_12266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1531_12266",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPoint);
export default __webpack_public_path__ + "static/media/mapPoint.fb6983da9955f144a2a8a69d7b45b8ae.svg";
export { ForwardRef as ReactComponent };